import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../utils/hooks";
import useApiPost from "../../../hooks/PostData";
import { useFile } from "../../../context/FileProvider";
import { CreateGroupRes } from "../../../types/ResType";
import toast from "react-hot-toast";
import { ClipLoader } from "react-spinners";
import TextTranslate from "../../../utils/TextTranslate";

export default function DoneButton() {
  const CreateGroup = useAppSelector((state) => state.CreateGroup);
  const userData = useAppSelector((state) => state.userData);
  const navigate = useNavigate();
  const { loading, postData } = useApiPost();
  const { selectedFile } = useFile();

  if (CreateGroup.user_id.length === 0) return null;

  async function createGroupApi() {
    if (
      CreateGroup.group_name == "Group Name" ||
      CreateGroup.group_name == ""
    ) {
      return toast.error("Please Enter Group Name!", {
        position: "bottom-left",
      });
    }

    const createGroupFormData = new FormData();
    createGroupFormData.append("group_name", CreateGroup.group_name);
    createGroupFormData.append("group_icon", selectedFile!);
    createGroupFormData.append("pictureType", "group_icon");
    createGroupFormData.append(
      "group_description",
      CreateGroup.group_description,
    );

    CreateGroup.user_id.forEach((user_id) => {
      if (user_id != userData.user_id) {
        createGroupFormData.append("participants", user_id.toString());
      }
    });

    await (postData(
      "chat/create-group",
      createGroupFormData,
      "multipart/form-data",
    ) as Promise<CreateGroupRes>);

    toast.success("Group Created Successfully");
    navigate("/chat");
  }

  return (
    <div className="absolute inset-x-0 bottom-0 border-t border-black/[0.06] bg-secondary/95 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl dark:border-white/[0.08] lg:pb-4">
      <button
        type="button"
        onClick={() => void createGroupApi()}
        className="w-full rounded-xl bg-themeColor py-3.5 text-center text-[17px] font-semibold text-themeTextColor transition active:scale-[0.99]"
      >
        {loading ? (
          <ClipLoader size={18} color="currentColor" />
        ) : (
          <TextTranslate text="Done" />
        )}
      </button>
    </div>
  );
}
